// @owners { team: patients-team }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, Icon, LgPadding, ListDescription, ListItem, MdSpacing } from '@alto/design-system';
import React from 'react';

export const FamilyAccountActionSheet = () => {
  return (
    <ActionSheetV2 title="How family accounts work">
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>When you add a family member to your account:</Body>
        <MdSpacing />
        <ListItem
          fullBleed
          LeftContent={
            <Icon
              name="pillbottle"
              type="grey"
            />
          }
          descriptions={
            <ListDescription>
              <Body>You can manage their medications, including scheduling orders and requesting refills</Body>
            </ListDescription>
          }
        />
        <MdSpacing />
        <ListItem
          fullBleed
          LeftContent={
            <Icon
              name="shield"
              type="grey"
            />
          }
          descriptions={
            <ListDescription>
              <Body>You can update insurance on their behalf</Body>
            </ListDescription>
          }
        />
        <MdSpacing />
        <ListItem
          fullBleed
          LeftContent={
            <Icon
              name="message"
              type="grey"
            />
          }
          descriptions={
            <ListDescription>
              <Body>You’ll receive all messages regarding their prescriptions</Body>
            </ListDescription>
          }
        />
        <MdSpacing />
      </LgPadding>
    </ActionSheetV2>
  );
};
